<div id="main-wrapper">
    <div class="site-wrapper-reveal">
        <div class="position-relative w-100">
            <div class="d-flex align-items-center w-100">

                <img src="../../../assets/images/banners/tech-hiring-banner.png"
                    class="img img-responsive w-100 h-100 d-none d-md-block" width="100%" alt="Mobile Service Banner" />

                <img src="../../../assets/images/banners/tech-hiring-bannermobile.png"
                    class="img img-responsive d-block d-md-none" width="100%" alt="Mobile Application Banner" />
                <div class="position-absolute w-100 home-banner">
                    <div class="row h-100 w-100">
                        <div class="col-8 col-md-6 col-sm-7 banner-section">
                            <div class="align-items-center banner-content-title global_title global_banner_title title_banner_content"
                                role="heading" aria-level="1">
                                <span>Simplify Tech Hiring with Proven Recruiter Expertise</span>
                            </div>
                            <div class="global_sub_title global_banner_subtitle mt-3" role="heading" aria-level="1">
                                <span>Save time, reduce churn, and grow your team with a recruiter who already knows
                                    what works.</span>
                            </div>
                            <div class="col pt-lg-3 pt-0 pt-md-3 mt-lg-3">
                                <a href="contact" class="global_button   text-left col  text-white white_button"
                                    role="button" aria-label="View Contact Page" tabindex="0">
                                    <div class="dub-arrow"><img src="../../../assets/images/button/arrowWhite.png"
                                            alt="Contact to Explore" /></div>
                                    TALK TO OUR EXPERT
                                </a>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
       
    </div>
</div>

<div class="container">
    <div class="row py-2 py-md-4 py-lg-5 g-0 ">
        <div class="col">
            <h2 class="fw-semibold text_head text-center">
                From Context to Conversion-We Understand What Works
            </h2>
            <p class="global_section_content text-center">
              We believe great staffing is more than matching keywords. At Maganti IT, we assign recruiters who stay with your account, bringing deep technical knowledge and institutional insight to every search. They speak your language, understand your architecture, and know how each role fits into broader delivery goals. This leads to fewer mismatches, less rework, and more strategic hiring.
            </p>

        </div>
    </div>
</div>
<div class="bg_color">
    <div class="container py-3 pt-md-4 pt-lg-5">
        <div class="row g-0">
            <div class="col">
                <h2 class="fw-semibold text_head text-center m-0">
                    Here's why clients stay with us</h2>
            </div>
        </div>
    </div>
    <div class="container py-0 py-md-3 py-lg-3">
        <div class="row row-cols-1 row-cols-sm-2 row-cols-md-3 row-cols-lg-5 g-0 justify-content-center">
            <div class="col p-2">
                <div class="custom-card  p-3 flex-column border-gradient border-gradient-purple ">
                    <div>
                        <h2 class="fw-bold card-color">20+ years
                        </h2>
                    </div>
                    <div>
                        <p class="mb-0 text-center global_section_content line_height ">Experience in Staffing
                        </p>
                    </div>
                </div>
            </div>
            <div class="col p-2">
                <div class="custom-card  p-3 flex-column border-gradient border-gradient-purple ">
                    <h2 class="fw-bold card-color">95%+	</h2>
                    <p class="mb-0 text-center global_section_content line_height ">Placement Retention Rate
                    </p>
                </div>
            </div>
            <div class="col p-2">
                <div class="custom-card  p-3 flex-column border-gradient border-gradient-purple ">
                    <h2 class="fw-bold card-color">50%+	
                    </h2>
                    <p class="mb-0 text-center global_section_content line_height ">Recruiters with 10+ Years Tenure
                    </p>
                </div>
            </div>
            <div class="col p-2">
                <div class="custom-card  p-3 flex-column border-gradient border-gradient-purple">
                    <h2 class="fw-bold card-color">6+ years	
                    </h2>
                    <p class="mb-0 text-center global_section_content line_height ">Average Recruiter Tenure (vs. 2–3 industry avg)
                    </p>
                </div>
            </div>
            <div class="col p-2">
                <div class="custom-card  p-3 flex-column border-gradient border-gradient-purple">
                    <h2 class="fw-bold card-color">10+ years	
                    </h2>
                    <p class="mb-0 text-center global_section_content line_height ">Client & Consultant Relationships</p>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="container">
    <div class="row g-0 align-items-center  overflow-hidden py-3 py-lg-5 flex-row-reverse">
        <div class="col-lg-5  d-flex justify-content-center">
            <div class="image-section">
                <img src="../../../assets/images/tech-hiring/image (1).png"
                    class="img-fluid w-100 h-100 object-fit-cover" alt="Team working" />
            </div>
        </div>

        <!-- Text section -->
        <div class="col-lg-7 pt-3 p-lg-3 ">
            <h2 class=" mb-4 text_head lh ">End-to-End Technology Staffing Coverage</h2>
            <p class="global_section_content  mb-2">
                We deliver vetted professionals across high-demand technology domains.
            </p>
            <ul class="list-unstyled mt-3 custom-list">
                <li class="d-flex mb-2 global_section_content">
                    <span class="icon-wrapper me-2">
                        <svg viewBox="0 0 24 24" width="18" height="18">
                            <circle cx="12" cy="12" r="10" fill="#228BE6" />
                            <path d="M7 12.5l3 3.2 7-7" stroke="white" stroke-width="2" fill="none"
                                stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                    </span>
                    Cloud & DevOps Engineers
                </li>
                <li class="d-flex mb-2 global_section_content">
                    <span class="icon-wrapper me-2">
                        <svg viewBox="0 0 24 24" width="18" height="18">
                            <circle cx="12" cy="12" r="10" fill="#228BE6" />
                            <path d="M7 12.5l3 3.2 7-7" stroke="white" stroke-width="2" fill="none"
                                stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                    </span>
                    Software Developers (Backend, Frontend, Full Stack)
                </li>
                <li class="d-flex mb-2 global_section_content">
                    <span class="icon-wrapper me-2 ">
                        <svg viewBox="0 0 24 24" width="18" height="18">
                            <circle cx="12" cy="12" r="10" fill="#228BE6" />
                            <path d="M7 12.5l3 3.2 7-7" stroke="white" stroke-width="2" fill="none"
                                stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                    </span>
                    Data & AI/ML Engineers
                </li>
                <li class="d-flex mb-2 global_section_content">
                    <span class="icon-wrapper me-2">
                        <svg viewBox="0 0 24 24" width="18" height="18">
                            <circle cx="12" cy="12" r="10" fill="#228BE6" />
                            <path d="M7 12.5l3 3.2 7-7" stroke="white" stroke-width="2" fill="none"
                                stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                    </span>
                    ERP, CRM, and Integration Consultants
                </li>
                <li class="d-flex mb-2 global_section_content">
                    <span class="icon-wrapper me-2">
                        <svg viewBox="0 0 24 24" width="18" height="18">
                            <circle cx="12" cy="12" r="10" fill="#228BE6" />
                            <path d="M7 12.5l3 3.2 7-7" stroke="white" stroke-width="2" fill="none"
                                stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                    </span>
                    Cybersecurity, IAM, and IT Compliance
                </li>
                <li class="d-flex mb-2 global_section_content">
                    <span class="icon-wrapper me-2">
                        <svg viewBox="0 0 24 24" width="18" height="18">
                            <circle cx="12" cy="12" r="10" fill="#228BE6" />
                            <path d="M7 12.5l3 3.2 7-7" stroke="white" stroke-width="2" fill="none"
                                stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                    </span>
                    Public Sector Cleared Resources
                </li>
            </ul>
        </div>
    </div>
</div>

<div class="bg_color">
    <div class="container">
        <div class="row pt-3 pt-md-4 pt-lg-5 g-0">
            <div class="col">
                <h2 class="fw-semibold text_head text-center m-0">
                    What You Can Expect Working With Us
                </h2>
            </div>
        </div>
    </div>

    <div class="container-fluid text-center pt-lg-2 pb-lg-5 pb-4 px-2 px-md-5">
        <!-- First Row (4 cards) -->
        <div class="row g-0 ps-sm-0 justify-content-center ">
            <!-- Card 1 -->
            <div class="position-relative p-2 col-12 col-sm-6 col-md-4  col-lg-3 card-margin-top ">
                <div class="icon-circle d-flex justify-content-center align-items-center icon_bg">
                    <img src="../../../assets/images/tech-hiring/image (5).png" alt="Kevin Martin">
                </div>
                <div class=" testimonial-card-card px-2 pb-3 position-relative d-flex flex-column h-100">
                    <div class="ps-2">
                        <h2 class="fw-semibold mb-1 text-start">Long-Term Client Familiarity</h2>
                        <p class="mb-0 text_1 p-0 text-start"> Work with recruiters who stay on your account, bringing context, consistency, and smarter decisions.</p>
                    </div>
                </div>
            </div>

            <!-- Card 2 -->
            <div class="position-relative p-2 col-12 col-sm-6 col-md-4 col-lg-3 card-margin-top ">
                <div class="icon-circle d-flex justify-content-center align-items-center icon_bg">
                    <img src="../../../assets/images/tech-hiring/image (4).png" alt="Kevin Martin">
                </div>
                <div class=" testimonial-card-card px-2 pb-3 position-relative d-flex flex-column h-100">
                    <div class="ps-2">
                        <h2 class="fw-semibold mb-1 text-start">Technical Credibility That Builds Trust</h2>
                        <p class="mb-0 text_1 p-0 text-start"> We understand the technology that matters. This allows us to screen more effectively and avoid mismatches from day one.</p>
                    </div>
                </div>
            </div>

            <!-- Card 3 -->
            <div class="position-relative p-2 col-12 col-sm-6 col-md-4 col-lg-3 card-margin-top ">
                <div class="icon-circle d-flex justify-content-center align-items-center icon_bg">
                    <img src="../../../assets/images/tech-hiring/image (3).png" alt="Kevin Martin">
                </div>
                <div class=" testimonial-card-card px-2 pb-3 position-relative d-flex flex-column h-100">
                    <div class="ps-2">
                        <h2 class="fw-semibold mb-1  text-start">Speed Without Sacrificing Fit
                        </h2>
                        <p class="mb-0 text_1 p-0 text-start">Refined pipelines enable faster delivery of technically aligned talent without cutting corners.</p> 
                    </div>
                </div>
            </div>

           


            <!-- Second Row (3 cards centered) -->
            <!-- Card 5 -->
            <div class="position-relative p-2 col-12 col-sm-6 col-md-4 col-lg-3 card-margin-top ">
                <div class="icon-circle d-flex justify-content-center align-items-center icon_bg">
                    <img src="../../../assets/images/tech-hiring/image (9).png" alt="Kevin Martin">
                </div>
                <div class=" testimonial-card-card px-2 pb-3 position-relative d-flex flex-column h-100">
                    <div class="ps-2">
                        <h2 class="fw-semibold mb-1  text-start">Talent Engagement That Lasts</h2>
                        <p class="mb-0 text_1 p-0 text-start">We know how to attract and retain passive talent through credibility, clarity, and long term value.</p> 
                    </div>
                </div>
            </div>
 <!-- Card 4 -->
            <div class="position-relative p-2 col-12 col-sm-6 col-md-4 col-lg-3 card-margin-top ">
                <div class="icon-circle d-flex justify-content-center align-items-center icon_bg">
                    <img src="../../../assets/images/tech-hiring/image (8).png" alt="Kevin Martin">
                </div>
                <div class="testimonial-card-card px-2 pb-3 d-flex flex-column h-100 position-relative">
                    <div class="ps-2">
                        <h2 class="fw-semibold mb-1  text-start">Culture Conscious Talent Matching
                        </h2>
                        <p class="mb-0 text_1 p-0 text-start">We tailor our approach to match your team’s culture, whether you need public sector precision or startup agility.</p> 
                    </div>
                </div>
            </div>
            <!-- Card 6 -->
            <div class="position-relative p-2 col-12 col-sm-6 col-md-4 col-lg-3 card-margin-top ">
                <div class="icon-circle d-flex justify-content-center align-items-center icon_bg">
                    <img src="../../../assets/images/tech-hiring/image (6).png" alt="Kevin Martin">
                </div>
                <div class=" testimonial-card-card px-2 pb-3 position-relative d-flex flex-column h-100">
                    <div class="ps-2">
                        <h2 class="fw-semibold mb-1 text-start">Focus on Long Term Performance
                        </h2>
                        <p class="mb-0 text_1 p-0 text-start"> Our candidates are vetted for retention and impact, not just to check a box.</p>
                    </div>
                </div>
            </div>

            <!-- Card 7 -->
            <div class="position-relative p-2 col-12 col-sm-6 col-md-4 col-lg-3 card-margin-top ">
                <div class="icon-circle d-flex justify-content-center align-items-center icon_bg">
                    <img src="../../../assets/images/tech-hiring/image (7).png" alt="Kevin Martin">
                </div>
                <div class=" testimonial-card-card px-2 pb-3 position-relative d-flex flex-column h-100">
                    <div class="ps-2">
                        <h2 class="fw-semibold mb-1  text-start">A Smarter Hiring Partner
                        </h2>
                        <p class="mb-0 text_1 p-0 text-start"> We challenge assumptions and ask the right questions because better hires begin with better insight.</p>
                    </div>
                </div>
            </div>
        </div>

    </div>
</div>


<div class="container text-center py-lg-5 py-4">
    <h2 class="mb-5 text_head pb-2">What Clients Say</h2>
    <div class="row g-0 ps-2 ps-sm-0">

        <!-- Testimonial Card 1 -->
        <div class="testimonial-wrapper mx-auto col-4">
            <!-- Blue ring behind the card -->
            <div class="profile-ring"></div>
            <!-- Profile image on top of the card -->
            <div class="profile-pic">
                <img src="../../../assets/images/tech-hiring/placeholder-profile-icon-20tehfawxt5eihco.png"
                    alt="Kevin Martin">
            </div>
            <!-- Card -->
            <div class="testimonial-card">
                <div class="stars  text-start">★★★★★</div>
                <p class="global_section_content testimonial-text">
                    “Our Maganti recruiter understood our stack better than some of our engineers.
                    They didn’t just find people-they found the right people.”
                </p>
                <div class="name-role">
                    <p class="name"></p>
                    <p class="role">Enterprise SaaS</p>
                </div>


            </div>
        </div>

        <!-- Testimonial Card 2 -->
        <div class="testimonial-wrapper mx-auto col-4 mt-5 mt-md-0 card_margin">
            <!-- Blue ring behind the card -->
            <div class="profile-ring"></div>
            <!-- Profile image on top of the card -->
            <div class="profile-pic">
                <img src="../../../assets/images/tech-hiring/placeholder-profile-icon-20tehfawxt5eihco.png"
                    alt="Kevin Martin">
            </div>
            <!-- Card -->
            <div class="testimonial-card">
                <div class="stars text-start">★★★★★</div>
                <p class="global_section_content testimonial-text">
                    “They know our team, they know our pain points, and we trust them to fill roles without
                    micromanaging.”
                </p>
                <div class="name-role">
                    <p class="name"></p>
                    <p class="role">Co Founder</p>
                </div>
            </div>
        </div>



        <!-- Testimonial Card 3 -->
        <div class="testimonial-wrapper mx-auto  col-4  card_margin  mt-md-0">
            <!-- Blue ring behind the card -->
            <div class="profile-ring"></div>
            <!-- Profile image on top of the card -->
            <div class="profile-pic">
                <img src="../../../assets/images/tech-hiring/placeholder-profile-icon-20tehfawxt5eihco.png"
                    alt="Kevin Martin">
            </div>
            <!-- Card -->
            <div class="testimonial-card">
                <div class="stars text-start">★★★★★</div>
                <p class="global_section_content testimonial-text">
                    “They’ve been with us longer than some of our internal HR staff. That kind of partnership is
                    rare.”
                </p>
                <div class="name-role">
                    <p class="name"></p>
                    <p class="role">Chief Executive Officer</p>
                </div>
            </div>
        </div>

    </div>
</div>



<div class="bg_color">
    <div class="team-section container py-5 ">
        <div class="row align-items-center justify-content-center g-0">
            <!-- Visual Area -->
            <div class="col-12 col-lg-5 position-relative d-flex justify-content-center mb-5 mb-lg-0">
                <div class="circle-wrapper">
                    <div class="dashed-circle outer-circle"></div>
                    <div class="dashed-circle inner-circle"></div>

                    <img src="../../../assets/images/tech-hiring/image (6).jpg" class="circle-img img-1"
                        alt="Person 1" />
                    <img src="../../../assets/images/tech-hiring/image (7).jpg" class="circle-img img-2"
                        alt="Person 2" />
                    <img src="../../../assets/images/tech-hiring/image (5).jpg" class="circle-img img-3"
                        alt="Person 3" />
                </div>
            </div>

            <!-- Text Content -->
            <div class="col-12 col-lg-7 text-center text-lg-start px-4">
                <h2 class="text_head">Build Teams That Drive Results</h2>
                <p class="global_section_content">
                    Work with a partner who already understands your world and delivers the kind of talent you don’t have to second-guess.
                </p>
                <a href="contact" class="global_button btn_color mt-2 text-left col  text-white white_button"
                    role="button" aria-label="View Contact Page" tabindex="0">
                    <div class="dub-arrow"><img src="../../../assets/images/button/arrowWhite.png"
                            alt="Contact to Explore" /></div>
                    SCHEDULE A CALL
                </a>
            </div>
        </div>
    </div>
</div>


<section class="py-5 bg-light">
  <div class="container">
    <div class="text-center h2 mb-5 fw-bold">Frequently Asked Questions</div>

    <div class="accordion" id="faqAccordion">

      <div class="row justify-content-center g-0">

        <div class="col-12 col-lg-9">

          <!-- Item 1 -->
          <div class="accordion-item mb-3 shadow-sm border-0 rounded">
            <h2 class="accordion-header" id="headingOne">
              <button class="accordion-button collapsed fw-semibold" type="button" data-bs-toggle="collapse"
                data-bs-target="#collapseOne" aria-expanded="false" aria-controls="collapseOne">
                Can Maganti IT help with hard-to-find or niche technical skills?
              </button>
            </h2>
            <div id="collapseOne" class="accordion-collapse collapse" data-bs-parent="#faqAccordion">
              <div class="accordion-body">
Yes. We have sourcing capabilities for legacy tech, emerging stacks, and roles requiring special certifications or clearances.               </div>
            </div>
          </div>

          <!-- Item 2 -->
          <div class="accordion-item mb-3 shadow-sm border-0 rounded">
            <h2 class="accordion-header" id="headingTwo">
              <button class="accordion-button collapsed fw-semibold" type="button" data-bs-toggle="collapse"
                data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                Are your staffing services available for federal and state contracts?
              </button>
            </h2>
            <div id="collapseTwo" class="accordion-collapse collapse" data-bs-parent="#faqAccordion">
              <div class="accordion-body">
                Yes. We have hands on experience with public sector procurement, SLAs, and vendor compliance requirements. 
              </div>
            </div>
          </div>

          <!-- Item 3 -->
          <div class="accordion-item mb-3 shadow-sm border-0 rounded">
            <h2 class="accordion-header" id="headingThree">
              <button class="accordion-button collapsed fw-semibold" type="button" data-bs-toggle="collapse"
                data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                How does Maganti IT ensure diversity and inclusion in staffing? 
              </button>
            </h2>
            <div id="collapseThree" class="accordion-collapse collapse" data-bs-parent="#faqAccordion">
              <div class="accordion-body">
                We promote inclusive hiring and are certified MBE, WBE, and WOSB. We present diverse candidate slates aligned to your D&I goals. 
              </div>
            </div>
          </div>

          <!-- Item 4 -->
          <div class="accordion-item mb-3 shadow-sm border-0 rounded">
            <h2 class="accordion-header" id="headingFour">
              <button class="accordion-button collapsed fw-semibold" type="button" data-bs-toggle="collapse"
                data-bs-target="#collapseFour" aria-expanded="false" aria-controls="collapseFour">
                What guarantees do you provide for your placements? 
              </button>
            </h2>
            <div id="collapseFour" class="accordion-collapse collapse" data-bs-parent="#faqAccordion">
              <div class="accordion-body">
                We offer a 30–90 day replacement guarantee for contract, contract-to-hire, and direct hire roles. Quick Turn around, highly skilled resources and long time committed.  
              </div>
            </div>
          </div>

          <!-- Item 5 -->
          <div class="accordion-item mb-3 shadow-sm border-0 rounded">
            <h2 class="accordion-header" id="headingFive">
              <button class="accordion-button collapsed fw-semibold" type="button" data-bs-toggle="collapse"
                data-bs-target="#collapseFive" aria-expanded="false" aria-controls="collapseFive">
                How is your pricing structured? 
              </button>
            </h2>
            <div id="collapseFive" class="accordion-collapse collapse" data-bs-parent="#faqAccordion">
              <div class="accordion-body">
                Flexible models based on role type and engagement: hourly, daily, flat-fee, or percentage. We also offer volume and retainer pricing following industry standards and are open for negotiation. 
              </div>
            </div>
          </div>

          <!-- Item 6 -->
          <div class="accordion-item mb-3 shadow-sm border-0 rounded">
            <h2 class="accordion-header" id="headingSeven">
              <button class="accordion-button collapsed fw-semibold" type="button" data-bs-toggle="collapse"
                data-bs-target="#collapseSeven" aria-expanded="false" aria-controls="collapseSeven">
                How do you ensure cultural fit and communication alignment?
              </button>
            </h2>
            <div id="collapseSeven" class="accordion-collapse collapse" data-bs-parent="#faqAccordion">
              <div class="accordion-body">
                We coordinate onboarding to ensure role clarity, tool access, and cultural integration.
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</section>